import * as t from "./actionTypes";
import { setToken, destroyToken } from "../api";

const tokenMiddleware = store => next => action => {
  switch (action.type) {
    // eslint-disable-next-line
    case t.LOGIN_REQUEST_SUCCESS:
      const token = action.payload;
      localStorage.setItem("token", JSON.stringify(token));
      setToken(token);
      return next(action);
    case t.LOGOUT_USER:
      destroyToken();
      return next(action);
    default:
      return next(action);
  }
};

export default tokenMiddleware;



// WEBPACK FOOTER //
// ./src/redux/middleware.js